__turbopack_context__.v({
  "bigDesktopPageWidth": "_4hMkbq_bigDesktopPageWidth",
  "body": "_4hMkbq_body",
  "chevron": "_4hMkbq_chevron",
  "chevronRotated": "_4hMkbq_chevronRotated",
  "desktopPageWidth": "_4hMkbq_desktopPageWidth",
  "faqAnswer": "_4hMkbq_faqAnswer",
  "faqContainer": "_4hMkbq_faqContainer",
  "faqQuestion": "_4hMkbq_faqQuestion",
  "faqSection": "_4hMkbq_faqSection",
  "open": "_4hMkbq_open",
  "root": "_4hMkbq_root",
  "sanitized": "_4hMkbq_sanitized",
  "threeLineEllipse": "_4hMkbq_threeLineEllipse",
});
